var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-allied-party"},[(_vm.player.alliedParty)?_c('div',{staticClass:"allied-policy-block"},[_c('AlliedPartyAgenda',{attrs:{"id":_vm.player.alliedParty.agenda.policyId}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }